import { memo } from 'react';
import cn from 'classnames';
import { useAsync } from 'react-use';
import { ArrayUtils } from 'src/utils';
import { CommonService } from 'src/services';
import { Element } from 'src/components';
import RouterLink from 'src/components/links';
import { IStock } from '@zmedia/bm-common/modules';
import { isDown } from '@zmedia/bm-common/modules/utilities/utils';

export function StockBox() {
    const state = useAsync(CommonService.getStockList);
    const data = state.value?.data || {};
    const boards: IStock[] = data?.boards || [];

    if (ArrayUtils.isEmpty(boards)) {
        return null;
    }

    return (
        <RouterLink
            to="/tien-ich-gia-chung-khoan.epi"
            className={cn(
                'relative',
                'border-[rgba(0,136,134,0.2)] border border-solid',
                'rounded-[4px]',
                'w-[210px]',
                "bg-[url('https://baomoi-static.bmcdn.me/web/styles/img/stock-bg.png')]",
                'bg-cover',
                'bg-center',
                'px-[16px] pt-[8px] pb-[12px]',
                'block',
                'shrink-0'
            )}
        >
            <Element className="text-[#00615F] text-[10px] font-[800] leading-[1.6]">
                Chứng khoán
            </Element>
            <Element
                className={cn(
                    'mt-[4px]',
                    'flex justify-between',
                    'leading-[1.6]',
                )}
            >
                {boards.slice(0, 2).map((board, index) => {
                    return (
                        <Element className="text-[#000]" key={index}>
                            <Element
                                className={cn(
                                    'text-[12px] font-[900] ',
                                    'flex items-center',
                                    'after:relative',
                                    'after:inline-block after:w-0 after:h-0 after:ml-[8px]',
                                    'after:border-x-[5px] after:border-solid',
                                    {
                                        'after:border-t-[5px] after:border-t-[#DD3333] after:border-b-0':
                                            isDown(board.change),
                                        'after:border-b-[5px] after:border-b-[#00B295] after:border-t-0':
                                            !isDown(board.change),
                                    },
                                )}
                            >
                                {index > 0
                                    ? board.displayName.split('-')[0]
                                    : board.displayName}
                            </Element>
                            <Element
                                className={cn(
                                    'flex items-center',
                                    'text-[12px] font-bold',
                                )}
                            >
                                <Element>{board.Index}</Element>
                                <Element
                                    className={cn('ml-[4px]', {
                                        'text-[#DD3333]': isDown(board.change),
                                        'text-[#00B295]': !isDown(board.change),
                                    })}
                                >
                                    {board.percentChange}%
                                </Element>
                            </Element>
                        </Element>
                    );
                })}
            </Element>
        </RouterLink>
    );
}

export default memo(StockBox);
